class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector('input[name="language_code"]'),
      select: this.querySelector('select[name="language_code"]'), // Desktop select dropdown
      links: this.querySelectorAll('li[name="language_code"] a'), // Mobile language links
    };
    if (this.elements.select) {
      this.elements.select.addEventListener(
        "change",
        this.onSelectChange.bind(this)
      );
    }

    if (this.elements.links?.length > 0) {
      this.elements.links.forEach((link) => {
        link.addEventListener("click", this.onLinkClick.bind(this));
      });
    }
  }
  onSelectChange(event) {
    this.elements.input.value = event.target.value;
    const form = this.querySelector("form");
    if (form) form.submit();
  }
  onLinkClick(event) {
    event.preventDefault();
    const selectedLanguage = event.target.getAttribute("data-value");
    this.elements.input.value = selectedLanguage;
    const form = this.querySelector("form");
    if (form) form.submit();
  }
}

customElements.define("localization-form", LocalizationForm);
